
<template>
  <div class="page" ref="pageRef">
    <div class="page_top_bg">
      <img
        src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937195424/news_top_bg.png"
      />
    </div>
    <div class="page_wrap">
      <div class="performance_tab">
        <div
          class="tab_item"
          :class="tabIndex == 1 ? 'tab_active' : ''"
          @click="handleChangeTab(1)"
        >
          公司新闻
        </div>
        <div
          class="tab_item"
          :class="tabIndex == 2 ? 'tab_active' : ''"
          @click="handleChangeTab(2)"
        >
          行业资讯
        </div>
        <div
          class="tab_item"
          :class="tabIndex == 3 ? 'tab_active' : ''"
          @click="handleChangeTab(3)"
        >
          招投标信息
        </div>
      </div>
      <div class="performance_table">
        <NScrollbar style="max-height: 800px">
          <div class="new_box" v-show="!isShowHtml">
            <div
              class="new_item"
              v-for="(item, index) in newsList"
              :key="index"
              @click="handleShowHtml(item)"
            >
              <div class="item_pic">
                <img :src="item.pic" alt="" />
              </div>
              <div class="item_right">
                <div class="item_time">
                  <span>{{ formatTime(item.createTime, "mm/dd") }}</span>
                  <span>{{ formatTime(item.createTime, "YYYY") }}</span>
                </div>
                <div class="item_title">{{ item.name }}</div>
                <div class="item_content">
                  {{ item.content.replace(/<[^>]+>/g, "") }}
                </div>
              </div>
            </div>
          </div>
          <div class="new_conetnt" v-show="isShowHtml">
            <div class="news_title">{{ showHtml.name }}</div>
            <div class="news_time">{{ showHtml.createTime }}</div>
            <div v-html="showHtml.content"></div>
            <div
              style="display: flex; justify-content: flex-end; cursor: pointer"
              @click="handleBack"
            >
              <NButton text> 返回列表 </NButton>
            </div>
          </div>
        </NScrollbar>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import qs from "qs";
import { formatTime } from "@/utils/scrollToAnchor";
import { NButton, NScrollbar } from "naive-ui";
import { useRoute } from "vue-router";
import {
  defineComponent,
  toRefs,
  reactive,
  getCurrentInstance,
  onMounted,
  ref,
  watchEffect,
} from "vue";

export default defineComponent({
  components: {
    NButton,
    NScrollbar,
  },
  setup() {
    const { proxy } = getCurrentInstance() as any;

    const state = reactive({
      isShowHtml: false,
      showHtml: {} as any,
      tabIndex: 1,
      newsList: [] as any,
    });
    const handleShowHtml = (item: any) => {
      state.showHtml = item;
      state.isShowHtml = true;
    };
    const pageRef = ref();
    const scrollToTop = () => {
      if (pageRef.value) {
        pageRef.value.scrollIntoView({ behavior: "smooth" });
      }
    };
    const handleBack = () => {
      state.showHtml = {};
      state.isShowHtml = false;
      scrollToTop();
    };
    const handleChangeTab = (val: any) => {
      handleBack();
      state.tabIndex = val;
      getNews(val);
    };
    const getNews = async (type: any) => {
      try {
        let params = {
          type: type,
          status: 1,
        };
        const url = `/api/t_base_content/list`; // 通过代理路径访问
        const response = await fetch(url, {
          method: "POST",
          body: qs.stringify(params),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP Error! 状态码: ${response.status}`);
        }

        const data = await response.json();
        state.newsList = data.data;
      } catch (error) {
        console.error("请求失败:", error);
      }
    };

    const route = useRoute();

    watchEffect(() => {
      if (route.query.type) {
        handleChangeTab(route.query.type);
      }
    });
    onMounted(() => {
      getNews(state.tabIndex);
    });
    return {
      handleChangeTab,
      handleBack,
      handleShowHtml,
      formatTime,
      ...toRefs(state),
    };
  },
});
</script>
<style scoped lang="scss">
.page {
  padding-bottom: 64px;
  .page_top_bg {
    width: 100%;
    height: 426px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 426px;
      object-fit: cover;
    }
  }
  .page_wrap {
    width: 1200px;
    margin: -60px auto 0px;
    position: relative;
    z-index: 10;
    background: #ffffff;
    border-radius: 16px;
    padding: 40px 0px;
    .performance_tab {
      display: flex;
      justify-content: center;
      .tab_item {
        margin: 0 12px;
        width: 160px;
        height: 40px;
        background: #f1f5f9;
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        cursor: pointer;

        font-weight: 600;
        font-size: 16px;
        color: #333333;
      }
      .tab_active {
        background: #377dca;
        color: #ffffff;
      }
    }
    .performance_table {
      min-height: 800px;
      padding: 40px 40px 0px;
      .new_box {
        .new_item {
          margin-bottom: 40px;
          cursor: pointer;
          display: flex;
          .item_pic {
            width: 372px;
            height: 218px;
            border-radius: 4px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .item_right {
            padding-left: 24px;
            width: calc(100% - 372px);
            .item_time {
              width: 100%;
              padding-bottom: 12px;
              border-bottom: 1px solid #d9d9d9;
              span:nth-of-type(1) {
                font-size: 40px;
                color: #000000;
              }
              span:nth-of-type(2) {
                font-size: 14px;
                color: #000000;
                padding-left: 16px;
              }
            }
            .item_title {
              padding: 16px 0px 12px;
              font-weight: 600;
              font-size: 20px;
              color: #000000;
            }
            .item_content {
              font-size: 14px;
              color: #666666;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3; //多行在这里修改数字即可
              overflow: hidden;
              /* autoprefixer: ignore next */
              -webkit-box-orient: vertical;
            }
          }
        }
      }
      .new_conetnt {
        .news_title {
          font-size: 36px;
          color: #000000;
        }
        .news_time {
          font-size: 12px;
          color: #999999;
          padding: 25px 0px 32px;
        }
      }
    }
  }
}
</style>
  